export default {
      id: "icon-play-light-usage",
      viewBox: "0 0 47.604 47.604",
      url: __webpack_public_path__ + "icons.svg#icon-play-light",
      toString: function () {
        return this.url;
      }
    }